import { computed, effect, inject, Injectable, Signal } from '@angular/core';
import { UISizeExtendType } from '../models/ui-size-extend.model';
import { WebSocketService } from './websocket-service';
import { ResponsiveService } from './responsive-service';

@Injectable({
  providedIn: 'root',
})
export class SizeService {
  private readonly webSocketService: WebSocketService = inject(WebSocketService);
  private readonly responsiveService: ResponsiveService = inject(ResponsiveService);

  private readonly configUiSize: Signal<UISizeExtendType> = computed(
    () => this.webSocketService.config()?.uiSize || 'medium',
  );

  private readonly xsmallSizeScaleMap: Record<UISizeExtendType, string> = {
    xsmall: '6px',
    small: '8px',
    medium: '10px',
    large: '12px',
    xlarge: '14px',
  };

  private readonly smallSizeScaleMap: Record<UISizeExtendType, string> = {
    xsmall: '6px',
    small: '8px',
    medium: '10px',
    large: '12px',
    xlarge: '14px',
  };

  private readonly mediumSizeScaleMap: Record<UISizeExtendType, string> = {
    xsmall: '8px',
    small: '10px',
    medium: '12px',
    large: '14px',
    xlarge: '16px',
  };

  private readonly largeSizeScaleMap: Record<UISizeExtendType, string> = {
    xsmall: '10px',
    small: '12px',
    medium: '14px',
    large: '16px',
    xlarge: '18px',
  };

  private readonly xlargeSizeScaleMap: Record<UISizeExtendType, string> = {
    xsmall: '12px',
    small: '14px',
    medium: '16px',
    large: '18px',
    xlarge: '20px',
  };

  constructor() {
    effect(() => {
      switch (this.responsiveService.breakpoint()) {
        case 'xsmall':
          document.documentElement.style.fontSize = this.xsmallSizeScaleMap[this.configUiSize()];
          break;
        case 'small':
          document.documentElement.style.fontSize = this.smallSizeScaleMap[this.configUiSize()];
          break;
        case 'large':
          document.documentElement.style.fontSize = this.largeSizeScaleMap[this.configUiSize()];
          break;
        case 'xlarge':
          document.documentElement.style.fontSize = this.xlargeSizeScaleMap[this.configUiSize()];
          break;
        default:
          document.documentElement.style.fontSize = this.mediumSizeScaleMap[this.configUiSize()];
          break;
      }
    });
  }
}
